import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CSVDataService } from '@app/export/CSVDataService';
import { AdminService } from '@app/services/admin/admin.service';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-admin-institution-type',
  templateUrl: './admin-institution-type.component.html',
  styleUrls: ['./admin-institution-type.component.css']
})
export class AdminInstitutionTypeComponent implements OnInit, OnDestroy {
  @ViewChild('dt') table;
  @ViewChild('globalfilter') globalfilter;
  institutiontypes: any[] = [];
  groups: SelectItem[] = [];
  cols: any[];
  formdata;
  display = false;
  displayaddinstitutiontype = false;
  result = '';
  subscriptions: Subscription[] = [];
  value: any;

  constructor(
    private adminService: AdminService,
    private messageService: MessageService,
    public confirmationService: ConfirmationService,
    private institutionService: InstitutionsService) { }

  ngOnInit() {
    this.cols = [
      { field: 'prefix', header: 'Prefix' },
      { field: 'name', header: 'Typnamn' },
      { field: 'branchId', header: 'Gren' },
      { field: 'description', header: 'Beskrivning' },
      { field: 'institutionGroupDescription', header: 'Grupp' }
    ];
    this.getInstitutionTypes();
  }

  edit(formdata) {
    this.formdata = formdata;
    this.display = true;
  }

  getInstitutionTypes() {
    this.institutionService.getInstitutionTypes().subscribe(data => {
      if (data) {
        this.institutiontypes = data;
        this.getInstitutionGroups();
      }
    });
  }

  getInstitutionGroups() {
    this.adminService.GetInstitutionGroups().subscribe(data => {
      if (data) {

        data.forEach(d => {
          const record = {
            label: d.description, value: d.id
          };
          this.groups.push(record);

        });
        const emptyrecord = {
          label: '', value: null
        };
        this.groups.unshift(emptyrecord);
      }
    });
  }

  saveInstitutionType(evt) {
    this.adminService.UpdateInstitutionType(evt).subscribe(x => {
      this.display = false;
      this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Institutionstyp uppdaterad.' });
      this.getInstitutionTypes();
    });
  }

  saveAddInstitutionType(evt) {
    this.adminService.AddInstitutionType(evt).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Institutionstyp tillagd.' });
        this.getInstitutionTypes();
      }
    });
    this.displayaddinstitutiontype = false;
  }


  remove(rowData) {
    this.confirm(rowData);
  }

  confirm(rowdata) {
    this.confirmDialog(rowdata);
  }

  confirmDialog(rowdata): void {
     this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du radera vald institutionstyp?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
        this.deleteInstitutionType(rowdata);
      },
      reject: () => {
      }
    });
  }

  deleteInstitutionType(rowdata) {
    this.adminService.RemoveInstitutionType(rowdata).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Institutionstyp raderad.' });
        this.getInstitutionTypes();
      }
    });
  }

  cancelEdit() {
    this.display = false;
  }

  cancelAdd() {
    this.displayaddinstitutiontype = false;
  }
  addCommittee() {
    this.displayaddinstitutiontype = true;
  }

  exportToCSV() {

    // tslint:disable-next-line:max-line-length
    let firstrow = '';
    this.cols.forEach(c => {
      firstrow += c.header + ';';
    });

    const excelrecords: any[] = [];
    this.institutiontypes.forEach(r => {
      const row = {
        prefix: r.prefix,
        name: r.name,
        branchId: r.branchId,
        description: r.description,
        institutionGroupId: r.institutionGroupDescription
      }

      excelrecords.push(row);
    });
    const filnamn = 'OF_institutiontypes';

    CSVDataService.exportToCsv(filnamn + '.csv', excelrecords, firstrow);

  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    });
  }

  resetFilter() {
    this.table.reset();
    this.table.clearState();
    this.value = null;
    this.globalfilter.nativeElement.value = null;
  }
}
